import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ElectricianList.tsx");
